var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { instanceToPlain, plainToClass } from 'class-transformer';
import queries from 'constants/queries';
import { ReceptionDesk } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from './ApiService';
var EMPTY_FILTERS = {};
var ReceptionDeskService = /** @class */ (function (_super) {
    __extends(ReceptionDeskService, _super);
    function ReceptionDeskService() {
        var _this = _super.call(this) || this;
        _this.root = 'reception_desks';
        _this.successMessage = '';
        return _this;
    }
    ReceptionDeskService.prototype.useReceptionDesks = function (filters) {
        var _this = this;
        if (filters === void 0) { filters = EMPTY_FILTERS; }
        var params = {};
        if (filters.clinic_id != null) {
            params.clinic_id = filters.clinic_id;
        }
        if (filters.active !== undefined) {
            params.active = filters.active;
        }
        return useQuery([queries.receptionDesks, filters], function () {
            return _this.get(_this.root, params);
        }, {
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(ReceptionDesk, (data || []));
            }
        });
    };
    ReceptionDeskService.prototype.useReceptionDesk = function (id, enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        return useQuery([queries.receptionDesk, id], function () {
            return _this.get("".concat(_this.root, "/").concat(id));
        }, {
            enabled: enabled && !!id,
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(ReceptionDesk, data);
            }
        });
    };
    ReceptionDeskService.prototype.useCreateReceptionDesk = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var receptionDesk = _a.receptionDesk, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post(_this.root, {
                data: { reception_desk: instanceToPlain(receptionDesk) }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.receptionDesks);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    ReceptionDeskService.prototype.useUpdateReceptionDesk = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var receptionDesk = _a.receptionDesk, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(receptionDesk.getId()), {
                data: { reception_desk: instanceToPlain(receptionDesk) }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                queryClient.invalidateQueries(queries.receptionDesks);
                queryClient.invalidateQueries([queries.receptionDesk, variables.receptionDesk.getId()]);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    ReceptionDeskService.prototype.useAssignEmployees = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var receptionDeskId = _a.receptionDeskId, employeeIds = _a.employeeIds, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(receptionDeskId, "/assign_employees"), {
                data: { employee_ids: employeeIds }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                queryClient.invalidateQueries(queries.receptionDesks);
                queryClient.invalidateQueries([queries.receptionDesk, variables.receptionDeskId]);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    ReceptionDeskService.getInstance = function () {
        if (!ReceptionDeskService.instance) {
            ReceptionDeskService.instance = new ReceptionDeskService();
        }
        return ReceptionDeskService.instance;
    };
    return ReceptionDeskService;
}(ApiService));
export default ReceptionDeskService;
